import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function AISocialMediaPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Social Media, <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Supercharged</span> by Intelligence</>}
        description="We combine creative strategies with advanced AI to amplify your brand's voice and drive meaningful connections."
        bgImage="/assets/modern-social-media.png"
        primaryBtn={{ text: "Boost My Social", link: "/contact", icon: "ri-rocket-line" }}
        secondaryBtn={{ text: "View Success Stories", link: "/work", icon: "ri-eye-line" }}
      />

      <Section>
        <FeatureGrid 
          title="The Evolution of Social Engagement"
          subtitle="AI Integrated Social Media Marketing uses AI tools to transform how brands engage with audiences."
          items={[
            { title: 'Audience Insights', description: 'Pinpoint precise audience demographics and engagement times.', icon: 'ri-user-search-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Content Optimization', description: 'Generate and optimize content ideas that resonate.', icon: 'ri-article-line', color: 'from-purple-500 to-pink-500' },
            { title: 'Automated Engagement', description: 'Deploy AI chatbots for instant support and lead qualification.', icon: 'ri-robot-line', color: 'from-green-500 to-emerald-500' },
            { title: 'Performance Prediction', description: 'Predict outcomes and adjust campaigns in real-time.', icon: 'ri-line-chart-line', color: 'from-orange-500 to-red-500' },
            { title: 'Sentiment Analysis', description: 'Monitor social conversations to gauge public perception.', icon: 'ri-emotion-line', color: 'from-indigo-500 to-purple-500' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="Smart Strategy, Seamless Execution"
          subtitle="Our AI-powered process ensures your social media works harder for you."
          steps={[
            { title: 'Strategic Audit', description: 'Analyze current presence & goals.', icon: 'ri-search-line', color: 'from-purple-500 to-pink-500' },
            { title: 'AI Integration', description: 'Implement tools for analysis.', icon: 'ri-settings-3-line', color: 'from-pink-500 to-red-500' },
            { title: 'Development', description: 'Craft data-backed content.', icon: 'ri-edit-line', color: 'from-red-500 to-orange-500' },
            { title: 'Deployment', description: 'Launch at optimal times.', icon: 'ri-rocket-line', color: 'from-orange-500 to-yellow-500' },
            { title: 'Monitoring', description: 'Track & refine with AI.', icon: 'ri-bar-chart-line', color: 'from-yellow-500 to-green-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Let's Make Your <span className="bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">Social Media Smarter</span></>}
        description="Partner with Hash Adz to unlock the full potential of AI-powered social media marketing."
        primaryBtn={{ text: "Start Project", link: "/contact" }}
        secondaryBtn={{ text: "Case Studies", link: "/work" }}
        stats={[
          { number: '250+', label: 'Campaigns' },
          { number: '98%', label: 'Satisfaction' },
          { number: '60+', label: 'Industries' }
        ]}
      />

      <Footer />
    </div>
  );
}